import { RecurrenceTypes } from '../../core/constants'

export const RECURRENCE_COPY = [
  { id: RecurrenceTypes.Unknown, copy: 'frequency_unknown' },
  { id: RecurrenceTypes.EveryWeek, copy: 'frequency_every_week' },
  { id: RecurrenceTypes.EveryOtherWeek, copy: 'frequency_every_other_week' },
  { id: RecurrenceTypes.EveryMonth, copy: 'frequency_every_month' },
  { id: RecurrenceTypes.EveryOtherMonth, copy: 'frequency_every_other_month' },
  { id: RecurrenceTypes.EveryQuarter, copy: 'frequency_every_quarter' },
  { id: RecurrenceTypes.EveryOtherQuarter, copy: 'frequency_every_other_quarter' },
  { id: RecurrenceTypes.EveryYear, copy: 'frequency_every_year' },
]
